import { AppConstants } from './constants'
import { MetricsConfigChart } from '@/lib/enums/bi-enums'

// Content strings
export abstract class Strings {
	// GLOBAL
	public static readonly WELCOME_TO_BOSS = 'Welcome to Broker Workplace!'
	public static readonly WELCOME_GET_STARTED = 'Sign in'
	public static readonly SIGNOUT_SCREEN_TITLE = 'Broker Workplace'
	public static readonly SIGNOUT_SCREEN_SUB_TITLE = 'Logging out'
	public static readonly SIGNOUT_SCREEN_MESSAGE = 'Please wait as we securely sign you out.'
	public static readonly CONFIRM_SIGNOUT_MESSAGE = 'Do you want to continue to log out?'
	public static readonly POPUP_CANCEL_BUTTON = 'Cancel'
	public static readonly POPUP_SIGNOUT_BUTTON = 'Log out'
	public static readonly SIGNOUT_BUTTON = 'Log out'
	public static readonly POPUP_OKAY_BUTTON = 'OK'
	public static readonly CONFIRM_SIGNOUT_TITLE = 'Log out?'
	public static readonly SOMETHING_WENT_WRONG = 'Something went wrong'
	public static readonly REFRESH_PAGE_AND_TRY_AGAIN = 'Please refresh the page and try again'
	public static readonly REFRESH_PAGE = 'Refresh page'
	public static readonly TIMEOUT_POPUP_MESSAGE = 'Your session expired. Please sign in again to continue.'
	public static readonly TIMEOUT_POPUP_TITLE = 'Session expired'

	public static readonly MIN_SUB_TITLE = 'Minimum'
	public static readonly MAX_SUB_TITLE = 'Maximum'
	public static readonly MIN_CAPTION = 'Select min.'
	public static readonly MAX_CAPTION = 'Select max.'
	public static readonly MINMAX_NOMIN = 'No min'
	public static readonly MINMAX_NOMAX = 'No max'

	public static readonly LISTING_STATUS_CLOSED = 'Closed'
	public static readonly LISTING_STATUS_OPEN = 'Opened'
	public static readonly LISTING_STATUS_PENDING = 'Pending'
	public static readonly LISTING_STATUS_PENDING_LINE = `${Strings.LISTING_STATUS_PENDING} (Line)`
	public static readonly LISTING_STATUS_OTHER_REVENUE = 'Other revenue'
	public static readonly LISTING_STATUS_LABEL_OTHER_REVENUE = 'Other\nrevenue'
	public static readonly LISTING_STATUS_YOUR_GOAL = 'Your goal'
	public static readonly LISTING_STATUS_LABEL_YOUR_GOAL = 'Your\ngoal'

	public static readonly TERMS_CONDITIONS_ERROR = 'Terms and conditions have not been accepted:'

	// BUSINESS INTELLIGENCE
	public static readonly GCI_CHART_SUBTITLE = 'GCI by month'
	public static readonly SIDES_CHART_SUBTITLE = 'Sides by month'
	public static readonly SALES_VOLUME_CHART_SUBTITLE = 'Sales volume by month'
	public static readonly Y_AXIS_CHART_LABEL = 'Value'
	public static readonly X_AXIS_CHART_LABEL = 'Category'
	public static readonly GCI_KEY = 'gci'
	public static readonly SIDES_KEY = 'sides'
	public static readonly SALES_VOLUME_KEY = 'salesVolume'
	public static readonly SEGMENTED_CONTROLLER_OPTION_YTD_LABEL = 'Year to date'
	public static readonly SEGMENTED_CONTROLLER_OPTION_YTD_LABEL_NEW_LAYOUT = 'Year to date (YTD)'
	public static readonly SEGMENTED_CONTROLLER_OPTION_YTD_VALUE = 'ytd'
	public static readonly SEGMENTED_CONTROLLER_OPTION_LTM_LABEL = 'Last 12 months'
	public static readonly SEGMENTED_CONTROLLER_OPTION_LTM_LABEL_NEW_LAYOUT = 'Last 12 months (LTM)'
	public static readonly SEGMENTED_CONTROLLER_OPTION_PY_LABEL_NEW_LAYOUT = 'Prior year'
	public static readonly SEGMENTED_CONTROLLER_OPTION_LTM_VALUE = 'ltm'
	public static readonly SEGMENTED_CONTROLLER_OPTION_PY_VALUE = 'month'
	public static readonly SEGMENTED_CONTROLLER_OPTION_L5Y_LABEL = 'Last 5 years'
	public static readonly SEGMENTED_CONTROLLER_OPTION_L5Y_LABEL_NEW_LAYOUT = 'Last 5 years (L5Y)'
	public static readonly SIDES_SELECTOR_OPTION_BOTH = 'Buy and sell'
	public static readonly SIDES_SELECTOR_OPTION_SELL = 'Sell'
	public static readonly SIDES_SELECTOR_OPTION_BUY = 'Buy'
	public static readonly TAB_GCI = 'GCI'
	public static readonly TAB_SIDES = 'Sides'
	public static readonly TAB_SALES_VOLUME = 'Sales volume'
	public static readonly GCI_TITLE = 'Gross commission income (GCI) - Company'
	public static readonly SIDES_TITLE = 'Sides - Company'
	public static readonly SALES_VOLUME_TITLE = 'Sales volume - Company'
	public static readonly CHART_TO_TABLE_BUTTON = 'Show chart as table'
	public static readonly YEAR_TO_DATE = 'Year to date'
	public static readonly UPDATED_TIME_INTIAL_LABEL_VALID = 'Data updated'
	public static readonly UPDATED_TIME_LABEL_INVALID = 'Data-update time unknown'
	public static readonly UPDATED_TIME_LABEL_DISCLAIMER = '1'

	// BI DASHBOARD - NEW LAYOUT
	public static readonly NEW_BI_DASHBOARD_TITLE = 'Performance'
	public static NEW_BI_DASHBOARD_SUB_TITLE(showOffice: boolean): string {
		if (showOffice) {
			return 'Company or office level metrics '
		}
		return 'Company level metrics'
	}
	public static readonly OPTION_GCI = 'Gross commission income (GCI)'
	public static readonly OPTION_SIDES = 'Sides'
	public static readonly OPTION_SALES_VOLUME = 'Sales volume'
	public static readonly CURRENT_LABEL = 'Current'
	public static readonly CONVERSION_LABEL = 'conversion'
	public static readonly YOY_CHANGE = 'Year-over-year (YoY) change'
	public static readonly CONFIGURE_LABEL = 'Customize'
	public static readonly TIMEFRAME_LABEL = 'Time period'
	public static readonly METRIC_LABEL = 'Business metric'
	public static readonly SALES_REVENUE = 'Sales revenue'
	public static readonly CLOSED_TRANSACTIONS = 'Closed transactions'
	public static readonly OPENED_TRANSACTIONS = 'Opened transactions'
	public static readonly GCI_LABEL = 'GCI'
	public static readonly SIDES_LABEL = 'Sides'
	public static readonly SALES_VOLUME_LABEL = 'Sales volume'
	public static readonly OTHER_REVENUE_LABEL = 'Other revenue'
	public static readonly OTHER_REVENUE_SUB_LABEL = 'Property management, lease, other non-sales'
	public static readonly OTHER_REVENUE_FOOTER_LABEL = 'YoY change'
	public static readonly REVENUE_BREAKDOWN_LABEL = 'Revenue breakdown'
	public static readonly REVENUE_DISTRUBTION_LABEL = 'Sales revenue distribution'
	public static readonly OTHER_REVENUE_DISTRUBTION_LABEL = 'Sales and other revenue distribution'
	public static readonly OTHER_REVENUE_DISTRUBTION_LABEL_DESCLAIMER = '2'
	public static readonly HEADER_SALES_CLOSED = 'Closed sales volume by month'
	public static readonly HEADER_SALES_OPENED = 'Opened sales volume by month'
	public static readonly HEADER_SIDES_CLOSED = 'Closed sides by month'
	public static readonly HEADER_SIDES_OPENED = 'Opened sides by month'
	public static readonly HEADER_GCI_CLOSED = 'Closed GCI by month'
	public static readonly HEADER_GCI_OPENED = 'Opened GCI by month'
	public static readonly TITLE_COMPARE_SALES = 'Sales revenue comparisons'
	public static readonly SUBTITLE_COMPARE_SALES = 'Comparison vs. prior year and benchmark'
	public static readonly SUBTITLE_COMPARE_SALES_DISCLAIMER = '1, 2'
	public static readonly COMPARE_LABEL = 'Compare'
	public static readonly SHOW_OTHER_REVENUE_LABEL = 'Show other revenue'
	public static readonly CONFIGURE_BENCHMARK = 'Configure benchmark'
	public static readonly SHOW_BENCHMARK = 'Show benchmark'
	public static readonly BENCHMARK_SUBTEXT = 'Compare your performance against an average of a selected affiliate group'
	public static readonly AFFILIATES_TEXT = 'Anywhere affiliates by annual GCI group'
	public static readonly BENCHMARK_OPTION_1 = 'Less than $1 million'
	public static readonly BENCHMARK_OPTION_2 = '$1 million to $4.9 million'
	public static readonly BENCHMARK_OPTION_3 = '$5 million to $9.9 million'
	public static readonly BENCHMARK_OPTION_4 = '$10 million to $19.9 million'
	public static readonly BENCHMARK_OPTION_5 = '$20 million or more'
	public static readonly CLOSE_TEXT = 'Close'
	public static readonly BACK_TEXT = 'Back'
	public static readonly APPLY_TEXT = 'Apply'
	public static readonly UPDATE = 'Update'
	public static readonly SAVE = 'Save'
	public static readonly UNDO = 'Undo'
	public static readonly TOTAL_TEXT = 'Total'
	public static readonly TNC_LOGOUT_BUTTON = 'Log out'
	public static readonly TNC_ACCEPT_BUTTON = 'Accept'
	public static readonly TNC_NAV_TITLE = 'Terms and Conditions'

	//FORECAST BI DASHBOARD V3
	public static readonly REVENUE_SUMMARY = 'Revenue summary'
	public static readonly PERFORMANCE_EMPTY_DATA_TITLE = 'Performance data not available'
	public static readonly PERFORMANCE_EMPTY_DATA_SUBTITLE =
		'Broker Workplace has no performance data for this time period.'

	// RECRUITING
	public static readonly TAB_PROSPECT_PIPELINE = 'Prospect pipeline'
	public static readonly TAB_PROSPECT_PIPELINE_M = 'Pipeline'
	public static readonly TAB_NURTURING = 'Nurture pool'
	public static readonly TAB_NURTURING_M = 'Nurture'
	public static readonly TAB_MLS_SEARCH = 'Prospect search'
	public static readonly TAB_SEARCH = 'Search'
	public static readonly TAB_ENGAGEMENT = 'Engagement'
	public static readonly TAB_INSIGHTS = 'Insights'
	public static readonly TAB_PRODUCTION = 'Production'
	public static readonly TAB_ACTIVITY = 'Activity'
	public static readonly TAB_DETAILS = 'Details'
	public static readonly TAB_INCENTIVE_ESTIMATOR = 'Incentive estimator'
	public static readonly MLS_AGENT_SEARCH = 'Prospect search'
	public static readonly LAST_12_MONTHS = 'Last 12 months'
	public static readonly LAST_90_DAYS = 'Last 90 days'
	public static readonly FILTER = 'Filter'
	public static readonly FILTERS = 'Filters'
	public static readonly CLEAR_ALL = 'Clear all'
	public static readonly APPLY = 'Apply'
	public static readonly RESET = 'Reset'
	public static readonly AGENT_NAME = 'Agent name'
	public static readonly BROKERAGE_NAME = 'Brokerage name'
	public static readonly HIGH_POTENTIAL = 'High potential'
	public static readonly AGENT_PHONE = 'Agent phone'
	public static readonly AGENT_EMAIL = 'Agent email'
	public static readonly MLS_TENURE = 'MLS tenure'
	public static readonly CLOSED_SIDES = 'Closed sides'
	public static readonly CLOSED_SIDES_CHANGE_PCT = 'YoY change'
	public static readonly CLOSED_SALES_VOL = 'Closed sales volume'
	public static readonly CLOSED_SALES_VOL_CHANGE_PCT = 'YoY change'
	public static readonly CO_BROKER_CNT = 'Co-broker deals'
	public static readonly ACTIVE_LISTINGS = 'Active listings'
	public static readonly PENDING_SIDES = 'Pending sides'
	public static readonly AVERAGE_SALES_PRICE = 'Average sales price'
	public static readonly AVG_SALES_PRICE = 'Avg. sales price'
	public static readonly ESTIMATED_GCI = 'Estimated GCI'
	public static readonly REPRESENTATION_FOCUS = 'Representation focus'
	public static readonly PRODUCTION_AREA = 'Primary production area'
	public static readonly ENTER_BROKERAGE_NAMES = 'Enter brokerage names'
	public static readonly DATA_RECEIVED = 'Data received'
	public static readonly SISTER_BRAND_AGENT = 'Sister brand agent'
	public static readonly GROWTH_SCORE = 'Growth score'
	public static readonly NET_REVENUE_SCORE = 'Net revenue score'
	public static readonly SIGNIN_ALERT_MESSAGE = "We're working to fix the error. Please try again later."
	public static readonly FILTER_HEADER_MLS_AFFILIATION_SELECTION = 'MLS selection'
	public static readonly ENTER_MLS = 'Enter MLS'
	public static readonly FILTER_HEADER_AGENT_PRODUCTION = 'Production and experience'
	public static readonly NO_SEARCH_RESULTS = 'No search results found'
	public static readonly TRY_AGAIN_WITH_DIFFERENT_FILTERS = 'Please try again with different filter selections'
	public static readonly UPDATE_FILTERS = 'Update filters'
	public static readonly NO_METRICS_DATA = 'No data'
	public static readonly NO_LISTINGS_TO_DISPLAY = 'There are no listings to display.'
	public static readonly MLS_ACTIVITY_EMPTY_TITLE = 'No activity to display'
	public static readonly MLS_ACTIVITY_EMPTY_MESSAGE =
		'The agent has not had any production activity in the last 90 days.'
	public static readonly MLS_ACTIVITY_ACTIVE = 'Listed'
	public static readonly MLS_ACTIVITY_PENDING = 'Pending sale for'
	public static readonly MLS_ACTIVITY_SOLD = 'Closed'
	public static readonly MLS_ACTIVITY_WITHDREW = 'Withdrew'
	public static readonly MLS_PIPELINE_LABEL_NEW_LISTING = 'New listing'
	public static readonly MLS_PIPELINE_LABEL_LISTING = 'Listing'
	public static readonly MLS_PIPELINE_EVENT_TYPE_LABELS: Record<string, string> = {
		PENDING: 'Pending sale',
		SOLD: 'Closed sale',
		WDRW: 'Withdrawn listing',
	}
	public static readonly MLS_PIPELINE_SIDE_LABELS: Record<string, string> = {
		BUY: 'Buyer',
		SELL: 'Seller',
		BOTH: 'Both',
	}

	public static readonly AGENTMANAGEMENT_NAME = 'Agent name'
	public static readonly PRIMARY_OFFICE = 'Primary office'
	public static readonly PRIMARY_OFFICE_NAME = 'Primary office name'
	public static readonly AGENT_POSITION = 'Position'
	public static readonly LICENSE_EXPIRATION = 'License expiration'
	public static readonly ACTIVE_LISTING = 'Active listings'
	public static readonly AVG_DAYS_LISTED = 'Avg. days listed'
	public static readonly PENDING_DEALS = 'Pending deals'
	public static readonly AVG_DAYS_PENDING = 'Avg. days pending'
	public static readonly CLOSED_SIDE = 'Closed sides'
	public static readonly CLOSED_VOLUME_AGENT = 'Closed volume'
	public static readonly CLOSED_GCI = 'Closed GCI'
	public static readonly CLOSED_ABCR = 'Closed ABCR'
	public static readonly ADD_TO_PIPELINE = 'Add to pipeline'
	public static readonly MOVE_TO_NURTURE_POOL = 'Move to nurture pool'
	public static readonly MOVE_TO_NURTURE = 'Move to nurture'
	public static readonly MANAGE_NURTURE_POOL = 'Manage nurture pool'
	public static readonly REMOVE_FROM_NURTURE_POOL = 'Remove from nurture pool'
	public static readonly PROSPECT_NOT_SAVED = 'Couldn’t save changes'
	public static readonly PROSPECT_NOT_SAVED_DETAIL =
		'We weren’t able to save the changes at this time. Please try again.'
	public static readonly PROSPECT_MANAGED_NURTURE_POOL = 'Nurture pool changes have been saved successfully.'
	public static readonly ADD = 'Add'
	public static readonly CONVERT_PIPELINE = 'Convert'
	public static readonly CONVERT_TO_AGENT = 'Convert to agent'
	public static readonly MANAGE_PIPELINE = 'Manage pipeline'
	public static readonly MANAGE_PROSPECT = 'Manage prospect'
	public static readonly MANAGE_NURTURE = 'Manage nurture pool'
	public static readonly MANAGE_PROSPECT_PIPELINE = 'Manage prospect pipeline'

	public static readonly MANAGE_PIPELINE_CTA = 'Manage'
	public static readonly PIPELINE_ACTIONS = 'Actions'
	public static readonly PIPELINE_MANAGEMENT = 'Pipeline management'
	public static readonly PROSPECT_MANAGEMENT = 'Prospect management'
	public static readonly AGENT_MANAGEMENT = 'Agent management'
	public static readonly PIPELINE_CONTACT_OPTIONS = 'Contact options'
	public static readonly ADD_AGENT_TO_PIPELINE = 'Add agent to pipeline'
	public static readonly CLOSING_RATE = 'Closing rate'
	public static readonly SALES_LIST_PRICE_RATIO = 'Sale/List price ratio'
	public static readonly DAYS_ON_MARKET = 'Days on market'
	public static readonly COBROKER_DEALS = 'Co-broker deals (%)'
	public static readonly REMOVE_FROM_PIPELINE = 'Remove from pipeline'
	public static readonly MOVE_TO_ = 'Remove from pipeline'
	public static readonly REMOVE_FROM_NURTURE = 'Remove from nurture'
	public static readonly EMPTY_NURTURE_POOL = 'No agent is in your pool.'
	public static readonly DELETE_ACTIVITY = 'Delete activity'
	public static readonly DELETE_INTERACTION = 'Delete interaction'
	public static readonly REMOVE = 'Remove'
	public static readonly REMOVE_FROM_PIPELINE_MODAL = {
		HEADER: 'Remove prospect',
		LAST_CONTACTED: 'Last contacted',
	}
	public static readonly REMOVE_FROM_PIPELINE_SNACKBAR = {
		SUCCESS: 'has been removed from your pipeline.',
		ERROR: 'Prospect could not be removed from pipeline',
	}
	public static readonly REMOVE_FROM_NURTURE_SNACKBAR = {
		SUCCESS: 'has been removed from your nurture pool.',
		ERROR: 'Prospect could not be removed from nurture pool',
	}
	public static readonly MANAGE_PIPELINE_SNACKBAR = {
		SUCCESS: 'Pipeline changes successfully updated.',
		ERROR: 'Pipeline could not be updated',
	}

	public static REMOVE_FROM_PIPELINE_CONFIRMATION(prospectName: string): string {
		return `Are you sure you want to remove ${prospectName} from your pipeline?`
	}

	public static REMOVE_FROM_NURTURE_CONFIRMATION(prospectName: string): string {
		return `Are you sure you want to remove ${prospectName} from your nurture pool?`
	}

	public static MOVE_TO_PIPELINE_CONFIRMATION(prospectName: string): string {
		return `${prospectName} was moved to your pipeline successfully. `
	}

	public static CONFIRM_CONVERSION_CONFIRMATION(prospectName: string, stageName: string): string {
		return `Conversion confirmed for ${prospectName}. Prospect removed from ${stageName}.`
	}

	static PAGE_STATE(page: number, pageCount: number): string {
		return `${page} of ${pageCount}`
	}

	static PAGINATION_RESULTS(first: number, last: number, resultsCount: number): string {
		return `Showing ${first}-${last} of ${resultsCount} results.`
	}

	static PAGINATION_RESULTS_SUBSET_AGENTS(
		first: number,
		last: number,
		pageSize: number,
		resultsCount: number,
		isGenericPagination?: boolean,
		isMLSListings?: boolean
	): string {
		const entityType = isMLSListings ? 'listings' : 'agents'
		return isGenericPagination
			? `Showing ${first}-${last} of ${resultsCount} results.`
			: `Showing ${first}-${last} of ${pageSize} results (out of ${resultsCount} ${entityType}).`
	}

	static MSL_SEARCH_TABLE_HEADER_NO_FILTER(pageSize: number): string {
		return ` Displaying the top ${pageSize} agents by volume. Apply filters to refine your search.`
	}

	static MLS_SEARCH_TABLE_HEADER_WITH_FILTER(pageSize: number): string {
		return ` Displaying the top ${pageSize} agents by volume based on your filters.`
	}

	public static readonly NURTURING_TABLE_SUBTITLE = "Prospects who aren't ready to engage."
	public static readonly AUTH_SIGNIN_LOADING = 'Signing in...'
	public static readonly AUTH_SIGNOUT_LOADING = 'Logging out...'

	public static readonly SEARCH_AGENT_PLACEHOLDER = 'Search by agent name'

	public static readonly LOADING_AGENTS = 'Loading agents...'
	public static readonly APPLYING_FILTERS = 'Applying filters...'
	public static readonly NO_MATCHES_FOUND = 'No matches found'
	public static readonly SELECT_STATUS = 'Select status'
	public static readonly PROPERTY_TYPE = 'Property type'
	public static readonly SELECT_TYPE = 'Select type'
	public static readonly TIMEFRAME = 'Timeframe'
	public static readonly REPRESENTATION_SIDE = 'Side'
	public static readonly SELECT_SIDE = 'Select side'
	public static readonly SELECT_FOCUS = 'Select focus'
	public static readonly CO_BROKER_DEALS = 'Co-broker deals'
	public static readonly CO_BROKER_DEALS_DESCRIPTION = 'Show listings co‑brokered with your agents.'
	public static readonly SELECT_ALL_ZIPCODES_WITH = 'Select all zip codes starting with'
	public static readonly PRIMARY_SERVICE_AREA = 'Primary service area'
	public static readonly ENTER_ZIP_CODES = 'Enter zip codes'
	public static readonly LOADING_DEFAULT = 'Loading...'
	public static readonly VIEW_FULL_PROFILE = 'View profile'
	public static readonly CLOSED_VOLUME = 'Closed volume'
	public static readonly FOCUS = 'Focus'
	public static readonly EMAIL = 'Email'
	public static readonly NOTE = 'Note'
	public static readonly CALL = 'Call'
	public static readonly TEXT = 'Text'
	public static readonly MEETING = 'Meeting'
	public static readonly DATE = 'Date'
	public static readonly ACTIVITY_DATE = 'Activity date'
	public static readonly RECRUITER = 'Recruiter'
	public static readonly ASSIGNED_RECRUITER = 'Assigned recruiter'
	public static readonly NURTURE_REASON = 'Nurture reason'
	public static readonly REASON_FOR_NURTURE = 'Reason for nurture'
	public static readonly LAST_MLS_ACTIVITY = 'Last MLS activity'
	public static readonly MOST_RECENT_PRODUCTION = 'Most recent production'
	public static readonly LAST_LOGGED_ACTIVITY = 'Last logged activity'
	public static readonly LAST_INTERACTION = 'Last interaction'
	public static readonly DONE_BY = 'Done by'
	public static readonly CANCEL = 'Cancel'
	public static readonly MLS_ACTIVITYY = 'Recent MLS activity'
	public static readonly SELECT_BRANDS = 'Select brands'
	public static readonly RECRUITING_ACTIVITY = 'Recruiting activity'
	public static readonly CONFIRM_CONVERSION = 'Confirm conversion'
	public static readonly CONFIRM = 'Confirm'

	public static readonly VIEW_ACTIVITY = 'View activity'
	public static readonly ACTIVITY_TYPE = 'Activity type'
	public static readonly AGENT_NAME_UNAVAILABLE = 'Agent Name Unavailable'
	public static readonly NA = 'N/A'
	public static readonly SEARCH_ERROR = 'Enter at least 2 characters'
	public static readonly AGENT_RESULTS = 'Prospect search results'
	public static readonly TRY_AGAIN_WITH_DIFFERENT_QUERY = 'Please try again with a different search query'
	public static readonly OVERVIEW = 'Overview'
	public static readonly PERFORMANCE = 'Performance'
	public static readonly MLS_ACTIVITY = 'MLS activity'
	public static readonly BROKERAGE_ACTIVITY = 'Brokerage activity'
	public static readonly DETAILS = 'Details'
	public static readonly ALL_TIME = 'All time'
	public static readonly BOTH_SIDES = 'Both sides'
	public static readonly LIST_SIDE = 'List side'
	public static readonly BUY_SIDES = 'Buy side'
	public static readonly PRIOR_YEAR = 'Prior year'
	public static readonly NAME = 'Name'
	public static readonly AGENT_INFORMATION = 'Agent information'
	public static readonly MLS_AGENT_ID = 'MLS ID'
	public static readonly VIEW_BROKERAGE_HISTORY = 'View brokerage history'
	public static readonly CURRENT_OFFICE = 'Current office'
	public static readonly INACTIVE_AGENT_OFFICE = 'Most recent office'
	public static readonly MLS_STATUS_INACTIVE = 'Inactive MLS member'
	public static readonly INACTIVE = 'Inactive'
	public static readonly MLS_STATUS_TOOLTIP_INACTIVE =
		"This shows the agent's MLS membership status. The status reflects standing within the MLS, not internal brokerage or recruiting status."
	public static readonly MLS_STATUS = 'MLS status'
	public static readonly MLS_MEMBERSHIP_STATUS = 'MLS membership status'
	public static readonly BROKERAGE = 'Brokerage'
	public static readonly OFFICE = 'Office'
	public static readonly PHONE = 'Phone'
	public static readonly ADDRESS = 'Address'
	public static readonly CITY_AND_ZIP = 'City and zip'
	public static readonly START_DATE = 'Start date'
	public static readonly OFFICE_INFORMATION = 'Office information'
	public static readonly DATE_OF_ASSOCIATION = 'Date of association'
	public static readonly TENURE = 'Tenure'
	public static readonly BROKERAGE_HISTORY_TABLE_TITLE = 'Brokerage history'
	public static readonly AGENT_ROSTER = 'Agent roster'
	public static readonly YOUR_AGENTS = 'Your Agents'
	public static readonly AGENT_ROSTER_SUB_TITLE = 'Active agents and their LTM production.'
	public static readonly NURTURING_TABLE_TITLE = 'Nurture pool'
	public static readonly CONNECTIONS = 'Connections'
	public static readonly MARKET_AND_AFFILIATIONS = 'Market and affiliation'
	public static readonly SISTER_BRAND_AGENT_TITLE = 'Include sister brand agents'
	public static readonly SISTER_BRAND_AGENT_SUBTITLE = 'Agents that are part of Anywhere.'
	public static readonly HIGH_POTENTIAL_AGENTS_TITLE = 'High potential agents only'
	public static readonly HIGH_POTENTIAL_SUBTITLE = 'Only show agents who are qualified as high potential.'
	public static readonly FORMER_AGENT_TITLE = 'Former agents'
	public static readonly FORMER_AGENT_SUBTITLE = 'Show formerly CBR-affiliated agents only.'
	public static readonly CBR_BRANDCODE = 'CBR'
	public static readonly MLS_SELECT_ERROR = 'Select at least one MLS'

	public static readonly DASHBOARD_FOOTER_DISCLAIMERS = (isLayoutVersion3: boolean = false) => [
		'Benchmark is calculated based on a selected group from approximately 1,800 affiliates.',
		isLayoutVersion3
			? 'This data is for informational purposes only and shall be used exclusively by franchisee for benchmarking their own business or for setting a goal for their own business, using a model-generated forecast as a potential suggestion. It shall not be used to discern any other brokerage’s confidential business metrics or be relied upon for making any decisions in connection with any merge, acquisition, or similar transaction.'
			: 'This data is for informational purposes only and shall be used exclusively by franchisee for benchmarking their own business. It shall be not used to discern any other brokerage’s confidential business metrics or be relied upon for making any decisions in connection with any merge, acquisition or similar transaction.',
	]

	static GOAL_SUCCESS_TEXT(year: number): string {
		return `Your ${year} goal has been saved.`
	}
	static GOAL_FAILURE_TEXT(year: number): string {
		return `Your ${year} goal wasn’t saved. Please try again.`
	}
	public static readonly BANNER_TEXT = (year: number) => `Get ready to set your ${year} GCI goal`
	public static readonly BANNER_SUBTEXT = (year: number) =>
		`Broker Workplace has prepared a ${year} forecast for you. You can use this to
								help set your own GCI goal.`
	public static readonly BANNER_CTA_TEXT = `Set your goal`
	public static readonly CONGRATULATIONS_TEXT = 'Congratulations!'
	public static readonly GOAL_DESCRIPTION_MODAL = (year: number) =>
		`Based on your historical performance and key macroeconomic indicators, here's a possible forecast for ${year}. You can use this forecast to help you set a goal for your business.`
	public static readonly DISMISS_BANNER_REMINDER_HEADER = 'Dismiss reminder?'
	public static readonly DISMISS_BANNER_REMINDER_TEXT = `You won't see this reminder until the next time you sign in. You can still set your annual goal on the <strong>Revenue breakdown</strong> chart.`
	public static readonly DISMISS_BANNER_REMINDER_CHECKBOX_TEXT = (year: number) =>
		`Hide reminder until time to create ${year} goals`
	public static readonly SET_GOAL_TEXT = (year: number) => `Set a ${year} goal`
	public static readonly GOAL_FORECAST_TEXT = (year: number) => `${year} Broker Workplace forecast`
	public static readonly YOUR_GOAL_TEXT = (year: number) => `Your ${year} goal`

	public static readonly PERFORMANCE_SECTION_TABLE_TITLE_CLOSED_SIDES_BOTH = 'Closed sides'
	public static readonly PERFORMANCE_SECTION_TABLE_TITLE_CLOSED_SIDES_LIST = 'Closed list sides'
	public static readonly PERFORMANCE_SECTION_TABLE_TITLE_CLOSED_SIDES_BUY = 'Closed buy sides'
	public static readonly PERFORMANCE_SECTION_TABLE_TITLE_CLOSED_SALES_VOL_BOTH = 'Closed sales volume'
	public static readonly PERFORMANCE_SECTION_TABLE_TITLE_CLOSED_SALES_VOL_LIST = 'Closed list sales volume'
	public static readonly PERFORMANCE_SECTION_TABLE_TITLE_CLOSED_SALES_VOL_BUY = 'Closed buy sales volume'
	public static readonly GOAL_SETTINGS_BUTTON_TEXT = 'Goal settings'
	public static readonly DISPLAY_CATEOGRY_BUTTON_TEXT = 'Display category'
	public static readonly RECRUTING_ACTIVITY_EMPTY_TITLE = 'No recruiting activity logged'
	public static readonly RECRUTING_ACTIVITY_EMPTY_MESSAGE =
		'Log an activity to start tracking engagement with this prospect.'
	public static readonly TARGET_OFFICE = 'Target office'
	public static readonly PIPELINE_STAGE = 'Pipeline stage'
	public static readonly TEAM_PIPELINE = 'Team pipeline'
	public static readonly YOUR_PIPELINE = 'Your pipeline'
	public static readonly YOUR_POOL = 'Your pool'
	public static readonly TEAM_POOL = 'Team pool'
	public static readonly PROSPECT_PIPELINE_TITLE = 'Prospect pipeline'
	public static readonly PROSPECT_PIPELINE_SUBTITLE = 'Your workspace for near-term recruiting efforts.'

	// User preferences default setting for attributes
	public static readonly BUSINESS_METRIC_DEFAULT = 'GCI'
	public static readonly REVENUE_SUMMARY_PERIOD_DEFAULT = 'YTD'
	public static readonly BI_PARAM_NAME = 'menu'
	public static readonly BI_PARAM_VALUE_LISTINGS = 'bi-listings'
	public static readonly BI_PARAM_VALUE_TRANSACTIONS = 'bi-transactions'
	public static readonly BI_PARAM_VALUE_AGENT_PRODUCTIVITY = 'bi-agent_productivity'
	public static readonly BI_TAB_COMPANY_PERFORMANCE = 'Performance'
	public static readonly BI_TAB_LISTINGS = 'Listings'
	public static readonly BI_TAB_TRANSACTIONS = 'Transactions'
	public static readonly BI_TAB_AGENT_PRODUCTIVITY = 'Agent productivity'
	public static readonly LOG_ACTIVITY = 'Log interaction'
	public static readonly INTERACTION_HISTORY = 'Interaction history'
	public static readonly RECRUITING_LOG = 'Recruiting log'
	public static readonly ACTIVITY = 'Activity'
	public static readonly EDIT_ACTIVITY = 'Edit activity'
	public static readonly SAVE_ACTIVITY = 'Save activity'
	public static readonly PIPELINE_ACTIVE_EVENT = 'New listing on'
	public static readonly PIPELINE_PENDING_EVENT = 'Pending deal on'
	public static readonly PIPELINE_SOLD_EVENT = 'Closed deal on'
	public static readonly LISTING_TODAY_SUMMARY = `Today's summary`
	public static readonly LISTING_SUMMARY_SUBTITLE = `Listings' statuses and top metrics`
	public static readonly LISTING_SUMMARY_ACTIVE_VOLUME = 'Active volume'
	public static readonly LISTING_SUMMARY_PENDING_VOLUME = 'Pending volume'
	public static readonly LISTING_SUMMARY_EXPIRING_WITHIN_30_DAYS = 'Expiring within 30 days'
	public static readonly LISTING_SUMMARY_OVER_90_DAYS_OLD = 'Over 90 days old'
	public static readonly CURRENT_STATUS_TEXT = 'Current status'
	public static readonly PIPELINE_STAGE_EMPTY = 'No prospects in pipeline'
	public static readonly PIPELINE_STAGE_EMPTY_MESSAGE =
		'Search for prospects in the MLS search to add them to your pipeline'
	public static readonly PIPELINE_STAGE_EMPTY_BUTTON = 'Search MLS'
	public static readonly LISTING_SELFREPORTING =
		"Accuracy of data is based on self-reporting from dash and can't be guaranteed."
	public static readonly DATA_RECEIVED_TIME_FOR_MLS = (mlsName: string, timestamp: string) =>
		`Data from ${mlsName} as of ${timestamp}. Accuracy may vary based on MLS reporting.`
	public static readonly MLS_REPORTING_CONTENT = 'Accuracy is subject to MLS reporting and may vary.'
	public static readonly METRICS = 'Metrics'
	// Business Intelligence Listings
	public static readonly LISTINGS = 'Listings'
	public static readonly METRICS_OVER_TIME_TITLE = 'Metrics over time'
	public static readonly METRICS_OVER_TIME_DESCRIPTION = "Your listings' metrics for your selected time period"
	public static readonly METRICS_OVER_TIME_SUMMARY_YTD = 'Summary (year to date)'
	public static readonly METRICS_OVER_TIME_SUMMARY_LTM = 'Summary (last 12 months)'
	public static readonly METRICS_OVER_TIME_SUMMARY_DESC_LTM = 'Listings’ statuses and top metrics for last 12 months'
	public static readonly METRICS_OVER_TIME_SUMMARY_DESC_YTD = 'Listings’ statuses and top metrics for year to date'
	public static readonly LISTINGS_ADDED = 'Listings added'
	public static readonly LISTINGS_PENDING = 'Pending'
	public static readonly LISTINGS_WITHDRAWN = 'Withdrawn, expired, or canceled'
	public static readonly LISTINGS_AVERAGE_PRICE = 'Average list price'
	public static readonly LISTINGS_AVERAGE_DAYS_ON_MARKET = 'Average days on market'
	public static readonly LISTINGS_SUMMARY_YOY = (percentage: number | string) => `${percentage}% year over year`
	public static readonly LISTINGS_MOVED_OFF_MARKET = 'Listings moved off-market'
	public static readonly LISTINGS_WENT_OFF_MARKET = (listings: number) =>
		`${listings} listings went off-market in the past 30 days.`
	public static readonly SHOW_OFF_MARKET_LISTINGS = 'Show off-market listings'
	public static readonly TRANSACTIONS_PAST_ESTIMATED_DATE = 'Transactions past estimated close date'
	public static readonly TRANSACTIONS_PAST_ESTIMATED_CLOSE = (count: number) =>
		`${count} transactions passed their estimated close date in the past 30 days`
	public static readonly SHOW_THERE_TRANSACTIONS = 'Show these transactions'
	public static readonly LISTINGS_YEAR_OVER_YEAR_LABEL = 'year over year'
	public static readonly AGENT_PRODUCTIVITY_YEAR_OVER_YEAR_LABEL = 'YoY'
	public static readonly DONUT_CHART_ACTIVE_LABEL = 'Active'
	public static readonly DONUT_CHART_OPENED_LABEL = 'Opened'
	public static readonly DONUT_CHART_PENDING_LABEL = 'Pending'
	public static readonly DONUT_CHART_ARIA_LABEL = (total: string, typeOf: string) =>
		`${typeOf} donut chart showing total ${total} ${typeOf}`
	public static readonly PROSPECT_ADDED_TO_PIPELINE = 'added to pipeline successfully.'
	public static readonly PROSPECT_MOVED_TO_NURTURE = 'was moved to nurture successfully.'
	public static readonly PROSPECT_NOT_ADDED = 'Couldn’t add to pipeline'
	public static readonly PROSPECT_NOT_MOVED = 'Couldn’t move prospect'
	public static readonly PROSPECT_NOT_ADDED_DETAIL =
		'We weren’t able to add this prospect to the pipeline at this time. Please try again.'
	public static readonly PROSPECT_NOT_MOVED_DETAIL = (name: string) =>
		`We weren’t able to move ${name} to the nurture pool at this time. Please try again.`
	public static readonly TRY_AGAIN = 'Try again'
	public static readonly ACTIVITY_NOT_LOGGED = 'Activity couldn’t be logged.'
	public static readonly ACTIVITY_NOT_UPDATED = 'Activity couldn’t be updated.'
	public static readonly ACTIVITY_NOT_DELETE_TITLE = 'We couldn’t delete this interaction.'
	public static readonly ACTIVITY_NOT_DELETE_INTERACTION = 'We couldn’t delete this interaction.'
	public static readonly ACTIVITY_NOT_UPDATE_TITLE = 'We couldn’t save your changes.'
	public static readonly ACTIVITY_NOT_LOGGED_TITLE = 'We couldn’t log this interaction.'
	public static readonly ACTIVITY_UPDATE_INTERACTION = 'We couldn’t save your changes.'
	public static readonly ACTIVITY_NOT_LOGGED_INTERACTION = 'We couldn’t log this interaction.'
	public static readonly TODO_NOT_LOGGED = 'To-do couldn’t be created.'
	public static readonly TODO_NOT_UPDATED = 'To-do couldn’t be updated.'
	public static readonly NOTES_NOT_LOGGED = 'Note couldn’t be logged.'
	public static readonly NOTES_NOT_LOGGED_DETAIL = 'Note couldn’t be logged.'
	public static readonly MOVE_TO_PIPELINE = 'Move to pipeline'
	public static readonly ACTIVITY_NOT_LOGGED_DETAIL = 'Activity couldn’t be logged. Please try again.'
	public static readonly ACTIVITY_NOT_UPDATED_DETAIL = 'Activity couldn’t be updated. Please try again.'
	public static readonly ACTIONS = 'Actions'
	public static readonly CONTACT_OPTIONS = 'Contact options'
	public static readonly PROPERTY_ADDRESS = 'Property address'
	public static readonly AGENT = 'Agent'
	public static readonly STATUS = 'Status'
	public static readonly DATE_LISTED = 'Date listed'
	public static readonly DATE_OFF_MARKET = 'Date off market'
	public static readonly LIST_PRICE = 'List price'
	public static readonly LISTINGS_IN_DEAL_PIPELINE_LTM = 'Listings in deal pipeline (last 12 months)'
	public static readonly LISTINGS_IN_DEAL_PIPELINE_YTD = 'Listings in deal pipeline (year to date)'
	public static readonly TRANSACTION_IN_DEAL_PIPELINE_YTD = 'Transactions in deal pipeline (year to date)'
	public static readonly TRANSACTION_IN_DEAL_PIPELINE_LTM = 'Transactions in deal pipeline (last 12 months)'
	public static readonly OFF_MARKET_LISTINGS_TITLE = 'Off-market listings (last 30 days)'
	public static readonly LISTING_STATUS_ADDED = 'Added'
	public static readonly SELECT_LISTING_STATUS = 'Select listing status:'
	public static readonly LISTING_STATUS_SHOW_BY_COUNT = 'Show by count'
	public static readonly LISTING_STATUS_SHOW_BY_VOLUME = 'Show by volume'
	public static readonly LISTING_BREAKDOWN_ADDED_AND_PENDING = 'Added and pending listings by count'
	public static readonly LISTING_STATUS_SHOW_BY_COUNT_VALUE = 'count'
	public static readonly LISTING_STATUS_SHOW_BY_VOLUME_VALUE = 'volume'
	public static readonly MULTISELECT_DROPDOWN_ALL = 'All'
	public static readonly MULTISELECT_DROPDOWN_NONE_SELECTED = 'None selected'
	public static readonly MULTISELECT_DROPDOWN_ERROR = 'Please select at least 1 status'
	public static readonly METRICS_OVER_TIME_BREAKDOWN_YTD = 'Listings breakdown (year to date)'
	public static readonly METRICS_OVER_TIME_BREAKDOWN_LTM = 'Listings breakdown (last 12 months)'
	public static readonly METRICS_OVER_TIME_BREAKDOWN_DESC_LTM =
		'Analysis of added and pending listings for last 12 months. "Pending" is the number of listings with that status during that month, not the number of listings that went pending that month.'
	public static readonly METRICS_OVER_TIME_BREAKDOWN_DESC_YTD =
		'Analysis of added and pending listings for year to date. "Pending" is the number of listings with that status during that month, not the number of listings that went pending that month.'
	public static readonly MANAGE_PIPELINE_ERROR_POPUP_TITLE = 'Couldn’t update the pipeline changes'
	public static readonly MANAGE_PIPELINE_ERROR_POPUP_DETAIL =
		'We weren’t able to update the pipeline changes at this time. Please try again.'
	public static readonly MOVE_TO_PIPELINE_ERROR_POPUP_TITLE = 'Couldn’t move prospect'
	public static readonly MOVE_TO_PIPELINE_ERROR_POPUP_DETAIL = (name: string) =>
		`We weren’t able to move ${name} to the nurture pool at this time. Please try again.`
	public static readonly LISTING_ERROR_BUTTON_LABEL = 'Refresh page'
	public static readonly DATA_LOADING_ERROR = 'Data loading error'

	// PERMISSION AND ACCESS MESSAGES
	public static readonly UNAUTHORIZED_ACCESS_TITLE = 'You don’t have access to Broker Workplace'
	public static readonly UNAUTHORIZED_ACCESS_SUBTITLE = 'Contact your admin to gain access.'
	public static readonly AUTH_ERROR_TITLE = 'Something went wrong'
	public static readonly AUTH_ERROR_SUBTITLE = 'An authentication error occurred. Please try signing in again.'
	public static readonly AUTH_ERROR_RETRY_BUTTON = 'Try Again'
	public static readonly ERROR_LOADING_PERMISSIONS =
		'An error occurred while loading permissions. Please try again later.'

	// EXP API ERROR
	public static readonly NETWORK_ERROR_TITLE = 'Service Unavailable'
	public static readonly NETWORK_ERROR_SUBTITLE =
		'We are experiencing temporary issues with the service. Please try again later.'
	public static readonly NETWORK_ERROR_RETRY_BUTTON = 'Try Again'
	// LISTING BREAKDOWN
	public static readonly LISTING_BREAKDOWN_ADDED = 'Added'
	public static readonly LISTING_BREAKDOWN_PENDING = 'Pending'
	public static readonly LISTING_BREAKDOWN_PENDING_LOWER = 'pending'
	public static readonly LISTING_BREAKDOWN_ERROR_DATA_TITLE = 'No listing status to display'
	public static readonly LISTING_BREAKDOWN_ERROR_DATA_SUBTITLE = 'Please select at least one listing status.'
	public static readonly LISTING_BREAKDOWN_ERROR_GRAPH_DATA_TITLE = 'Listings data not available'
	public static readonly LISTING_BREAKDOWN_ERROR_GRAPH_DATA_SUBTITLE =
		'Broker Workplace has no listings data for this time period.'
	public static readonly PIPELINE_DROPDOWN_UPDATE_FAILURE = 'We couldn’t save your changes. Please try again.'
	public static readonly MLS_CONTRACTS_EMPTY_STATE = 'No active MLS contract found'
	public static readonly MLS_CONTRACTS_EMPTY_STATE_DESCRIPTION =
		'Access to recruiting data requires an active MLS contract. To get started, please complete an MLS order form.'
	public static readonly MLS_CONTRACTS_EMPTY_STATE_LINK = 'MLS Order Form'

	public static readonly LISTINGS_EMPTY_DATA_TITLE = 'Listings data not available'
	public static readonly LISTINGS_EMPTY_DATA_SUBTITLE = 'Broker Workplace has no listings data for this time period.'
	public static readonly OFF_MARKET_LISTINGS_EMPTY_DATA_SUBTITLE = 'No listing has gone off market in the past 30 days.'
	public static readonly EXPORT_AS_CSV = 'Export as CSV'
	public static readonly EXPORT_ERROR_TITLE = 'Export table as CSV file'
	public static readonly EXPORT_ERROR_MESSAGE = 'Something went wrong. Please try again.'
	public static readonly RESTART_EXPORT = 'Restart export'
	public static EXPORT_FILE_NAME_LISTINGS(timestamp: string): string {
		return `Listings_${timestamp}.csv`
	}
	public static EXPORT_FILE_NAME_OFF_MARKET(timestamp: string): string {
		return `OffMarketListings_${timestamp}.csv`
	}

	public static LISTING_BREAKDOWN_CHART_TITLE(checkboxValue: string, segmentType: string): string {
		return ` ${checkboxValue} listings by ${segmentType}`
	}
	public static readonly OF = 'of'
	public static readonly TRANSACTIONS = 'Transactions'
	public static readonly TRANSACTION_SUMMARY_SUBTITLE = 'Transactions’ statuses and top metrics for buy and sell'
	public static readonly TRANSACTION_SUMMARY_OPENED_VOLUME = 'Opened volume'
	public static readonly TRANSACTION_SUMMARY_PAST_ESTIMATED_CLOSE_DATE = 'Past estimated close date'
	public static readonly TRANSACTIONS_METRICS_OVER_TIME_SUMMARY_DESC_YTD =
		'Transactions’ statuses and top metrics for year to date'
	public static readonly TRANSACTIONS_METRICS_OVER_TIME_SUMMARY_DESC_LTM =
		'Transactions’ statuses and top metrics for last 12 months'
	public static readonly TRANSACTIONS_METRICS_OVER_TIME_DESCRIPTION =
		'Your transactions’ metrics for your selected time period'
	public static readonly TRANSACTIONS_METRICS_OPENDED = 'Opened'
	public static readonly TRANSACTIONS_METRICS_CLOSED = 'Closed'
	public static readonly TRANSACTIONS_METRICS_PENDING = 'Pending'
	public static readonly TRANSACTIONS_METRICS_CANCELED = 'Canceled'
	public static readonly TRANSACTIONS_METRICS_AVERAGE_SALE_PRICE = 'Average sale price'
	public static readonly TRANSACTIONS_METRICS_AVERAGE_DAYS_TO_CLOSE = 'Average days to close'
	public static readonly TRANSACTIONS_METRICS_AVERAGE_BROKER_COMMISSION_RATE = 'Average broker commission rate'
	public static COMMISSION_RATE(commissionRate: number | string): string {
		return `${commissionRate}%`
	}
	public static readonly TRANSACTIONS_PAST_ESTIMATED_CLOSE_DATE =
		'Transactions past estimated close date (last 30 days)'
	public static readonly TRANSACTIONS_PAST_ESTIMATED_CLOSE_EMPTY_DATA_TITLE =
		'Transactions past estimated close data not available'
	public static readonly CONTRACT_DATE = 'Contract date'
	public static readonly ESTIMATED_CLOSE_DATE = 'Estimated close date'
	public static readonly CLOSED_DATE = 'Close date'

	public static readonly SALES_PRICE = 'Sales price'
	public static readonly AVERAGE_BROKER_COMMISSION_RATE = 'Average broker commission rate'
	public static readonly AVERAGE_SALE_PRICE_LABEL = 'Average sale price'
	public static readonly TRANSACTION_COUNT_LABEL = 'Transaction count'
	public static readonly GCI_METRICS_CONFIG_LABEL = 'GCI (Gross commission income)'
	public static readonly TRANSACTION_BREAKDOWN_TITLE = (activeSegmentIndex: number) => {
		if (activeSegmentIndex === 1) {
			return 'Transaction breakdown (last 12 months)'
		}
		return 'Transaction breakdown (year to date)'
	}
	public static readonly TRANSACTION_BREAKDOWN_SUBTITLE = (activeSegmentIndex: number) => {
		if (activeSegmentIndex === 1) {
			return `Analysis of transaction trends for  last 12 months. "Pending" is the number of transactions with that status during that month, not the number of transactions that went pending that month.`
		}
		return `Analysis of transaction trends for year to date. "Pending" is the number of transactions with that status during that month, not the number of transactions that went pending that month.`
	}
	public static readonly CONFIGURE_CHARTS = 'Configure charts'
	public static readonly TRANSACTION_CHART_TITLE = (metric: string, status: string) => {
		if (metric === MetricsConfigChart.GCI) {
			return `${status} GCI`
		}
		if (metric === MetricsConfigChart.SIDES) {
			return `${status} sides`
		}
		if (metric === MetricsConfigChart.SALES_VOLUME) {
			return `${status} sales volume`
		}
		if (metric === MetricsConfigChart.AVERAGE_BROKER_COMMISSION_RATE) {
			return `${status} average broker commission rate`
		}
		if (metric === MetricsConfigChart.AVERAGE_SALE_PRICE) {
			return `${status} average sale price`
		}
		if (metric === MetricsConfigChart.TRANSACTION_COUNT) {
			return `${status} transaction count`
		}
		return ''
	}
	public static readonly TRANSACTION_TABLE_TITLE = (chartTitle: string, activeSide: string) => {
		if (activeSide === 'both') {
			return `Both sides - ${chartTitle}`
		}
		if (activeSide === 'buy') {
			return `Buy side - ${chartTitle}`
		}
		return `Sell side - ${chartTitle}`
	}
	public static readonly AVG_BROKER_COMMISSION_RATE = 'ABCR'
	public static readonly AVG_SALE_PRICE = 'AVGSALEAM'
	public static readonly TRANSACTION_COUNT = 'TRXCT'
	public static readonly TRANSACTIONS_ERROR_TITLE = 'Transaction data not available'
	public static readonly TRANSACTIONS_ERROR_TITLE_NO_DATA =
		'Broker Workplace has no transaction data for this time period.'
	public static readonly TRANSACTIONS_ERROR_OFFMARKET_SUBTITLE =
		'No transactions are past their estimated close date in past 30 days'
	public static readonly PROSPECT_PIPELINE_WARNING_TITLE = (listings: number) =>
		`(${listings}/${AppConstants.PROSPECT_PIPELINE_MAX_LIMIT}) You're nearing your pipeline limit`
	public static readonly PROSPECT_PIPELINE_WARNING_DESCRIPTION =
		'Consider moving disengaged prospects to the Nurture pool or reassigning them.'
	public static readonly PROSPECT_PIPELINE_ERROR_TITLE = `(${AppConstants.PROSPECT_PIPELINE_MAX_LIMIT}/${AppConstants.PROSPECT_PIPELINE_MAX_LIMIT}) You've reached your pipeline limit`
	public static readonly PROSPECT_PIPELINE_ERROR_DESCRIPTION =
		'To add new prospects, please move disengaged agents to the Nurture pool or remove them from your pipeline.'
	public static readonly NURTURING_PIPELINE_WARNING_TITLE = (listings: number) =>
		`(${listings}/${AppConstants.NURTURING_PIPELINE_MAX_LIMIT}) You're nearing your nurture pool limit`
	public static readonly NURTURING_PIPELINE_WARNING_DESCRIPTION =
		'Consider removing disengaged prospects or reassigning them.'
	public static readonly NURTURING_PIPELINE_ERROR_TITLE = `(${AppConstants.NURTURING_PIPELINE_MAX_LIMIT}/${AppConstants.NURTURING_PIPELINE_MAX_LIMIT}) You've reached your nurture pool limit `
	public static readonly NURTURING_PIPELINE_ERROR_DESCRIPTION =
		'To add new prospects, consider removing disengaged agents.'
	public static readonly BOTH_SIDE_CLOSING_RATE = 'List side closing rate'
	public static readonly BOTH_SIDE_S_L_PRICE_RATIO = 'List side S/L price ratio'
	public static readonly BOTH_SIDE_DOM = 'List side DOM'
	public static readonly OFFICE_SELECTION_LABEL = 'Office selection'
	public static readonly ERROR_LOADING_OFFICES = 'Offices failed to load. Please refresh or try again later.'
	public static readonly PIPELINE_LIMIT = 'You’ve reached your pipeline limit. Remove prospects to add more.'
	public static readonly NURTURE_LIMIT = 'You’ve reached your nurture pool limit. Remove prospects to add more.'
	public static readonly YOUR_AGENT = 'Your agent'
	public static readonly SELECT_ONE_OR_MORE_MLS = 'Select one or more MLS'
	public static readonly BI_MULTI_COMPANY_BRAND_LABEL = 'Brand'
	public static readonly BI_MULTI_COMPANY_COMPANY_LABEL = 'Company'
	public static readonly BI_MULTI_COMPANY_CONTINUE_BUTTON = 'Continue'
	public static readonly BI_MULTI_COMPANY_ERROR_LOGOUT = 'Please log out and try again.'

	// Feedback Page
	public static readonly FEEDBACK_PAGE_TITLE = 'Feedback'
	public static readonly FEEDBACK_PAGE_SUBTITLE =
		'We value your feedback! Please share your thoughts and suggestions to help us improve your experience.'
	public static readonly FEEDBACK_TOOLTIP = 'Submit feedback, feature requests, and bug reports through Canny.io'
	public static readonly FEEDBACK_LINK_TEXT = 'Give feedback'
	public static readonly SEARCH = 'Search...'
	public static readonly AI_ASSISTANT_LABEL = 'AI Assistant'
	public static readonly AI_ASSISTANT_DESCRIPTION_1 =
		'By chatting, you consent to the chats being recorded, used, and shared by us and our service providers according to our'
	public static readonly AI_ASSISTANT_DESCRIPTION_PRIVACY_NOTICE = 'Privacy Notice'
	public static readonly AI_ASSISTANT_DESCRIPTION_2 =
		'Answers are generated by AI and may be inaccurate. Verify information before using it.'
	public static readonly AI_CATEGORY_DESCRIPTION = 'Here are a few suggestions for initial questions.'

	//AgentProductivity page
	public static readonly AGENT_PRODUCTIVITY = 'Agent productivity'
	public static AGENT_PRODUCTIVITY_SUBTITLE(showOffice: boolean): string {
		if (showOffice) {
			return 'Company or office level metrics by time period for buy and sell sides. '
		}
		return 'Metrics by time period for buy and sell sides'
	}
	// public static readonly AGENT_PRODUCTIVITY_SUBTITLE =
	// 	'Metrics by time period for buy and sell sides.'
	public static readonly AGENT_PRODUCTIVITY_TIME_PERIOD = 'Time period'
	public static readonly AGENT_PRODUCTIVITY_METRIC_GCI = 'PPP GCI'
	public static readonly AGENT_PRODUCTIVITY_METRIC_SIDES = 'PPP sides'
	public static readonly AGENT_PRODUCTIVITY_METRIC_SALES_VOLUME = 'PPP sales volume'
	public static readonly AGENT_PRODUCTIVITY_METRIC_TRANSACTIONS_CLOSED = 'PPP transactions closed'
	public static readonly AGENT_PRODUCTIVITY_METRIC_LISTINGS_TAKEN = 'PPP listings taken'
	public static readonly AGENT_PRODUCTIVITY_METRIC_SALE_LIST_PRICE_RATIO = 'Sale/list price ratio'
	public static readonly AGENT_PRODUCTIVITY_CURRENT_AGENT_LABEL =
		'Producing agents are active and have done at least 1 real estate activity in the past 12 months.'
	public static readonly AGENT_PRODUCTIVITY_AGENT_TYPE_TITLE =
		'&quot;All agents&quot; includes any agents that have contributed towards PPP metrics during the selected time period. &quot;PPP&quot; means per-person productivity.'
	public static readonly AGENT_RETENTION_GAINED = 'Total agents gained'
	public static readonly AGENT_RETENTION_LOST = 'Total agents lost'
	public static readonly AGENT_RETENTION_GCI = 'GCI retained/lost'
	public static readonly AGENT_RETENTION_PERCENTAGE = 'Percentage agents retained'
	public static readonly POSITION = 'Position'
	public static readonly BROKERAGE_TENURE = 'Brokerage tenure'
	public static readonly BIRTH_DATE = 'Birth date'
	public static readonly HIGH_POTENTIAL_DESCRIPTION =
		'The High Potential Indicator uses AI to predict if an agent will deliver strong performance and revenue over the next two years. It combines insights from growth, revenue, and commission models to identify agents most likely to succeed.'
	// AGENT RETENTION GRAPH
	public static readonly AGENT_RETENTION_GRAPH_TITLE =
		//'Agents gained/lost vs. GCI retained/lost'
		'Agents gained/lost'
	public static readonly AGENT_RETENTION_AGENTS_GAINED_LABEL = 'Agents gained'
	public static readonly AGENT_RETENTION_AGENTS_LOST_LABEL = 'Agents lost'
	// public static readonly AGENT_RETENTION_GCI_LABEL = 'GCI retained/lost'
	public static readonly AGENT_RETENTION_GCI_LABEL = ''
	public static readonly OFFICE_GOAL_WARNING_HEADER = 'Office view: No benchmarking or goal setting'
	public static readonly OFFICE_GOAL_WARNING_MESSAGE =
		"Benchmarking and goal setting aren't available when viewing individual offices."

	// Producing agent performance
	public static readonly AGENT_ERROR_TITLE = 'Agent data not available'
	public static readonly AGENT_ERROR_SUB_TITLE = 'Broker Workplace has no data for this comparison.'
	public static readonly GCI_QUARTILE_ERROR_TITLE = 'Data not available'
	public static readonly GCI_QUARTILE_ERROR_SUB_TITLE = 'Broker Workplace has no data for this table.'
	public static readonly PRODUCING_AGENT_PERFORMANCE_HEADING = 'Producing agent performance '
	public static readonly PRODUCING_AGENT_PERFORMANCE_SUB_HEADING =
		"Performance of producing agents, currently active, who've been with the company for at least 2 years."
	public static PRODUCING_AGENT_PERFORMANCE_PRODUCERS_TITLE(scale: string): string {
		return `${scale} producing agents`
	}
	public static PRODUCING_AGENT_PERFORMANCE_PRODUCERS_SUBTITLE(metric: string, scale: string): string {
		return `Agents with the ${scale} ${metric} during this time period with trend.`
	}

	public static PRODUCING_AGENT_PERCENT_INCR_SUBTITLE(metric: string): string {
		return `Agents with the largest year-over-year ${metric} increase during this time period with ${metric}.`
	}
	public static PRODUCING_AGENT_PERCENT_TITLE(metric: string, scale: string): string {
		return `Largest ${metric} percentage ${scale}`
	}
	public static PRODUCING_AGENT_PERCENT_SUBTITLE(metric: string, scale: string): string {
		return `Agents with the largest year-over-year ${metric} ${scale} during this time period with ${metric}.`
	}
	public static readonly PRODUCING_AGENT_PERCENT_DECR_TITLE = 'Largest GCI percentage decrease'
	public static readonly AGENT_RETENTION_TITLE = 'Agent retention'
	public static readonly AGENT_RETENTION_SUBTITLE =
		//'Gain or loss of agents and related GCI.'
		'Gain or loss of agents'

	static GCI_QUARTILE_PERFORMANCE_HEADING(timePeriod: string): string {
		return `GCI quartile performance (${timePeriod})`
	}
	public static readonly GCI_QUARTILE_PERFORMANCE_SUB_HEADING =
		'Producing agents ranked by GCI quartile. "PPP" means per-person productivity.'

	// GCI Quartile Performance Table Headers
	public static readonly GCI_QUARTILE_TABLE_HEADER_QUARTILE = 'Quartile'
	public static readonly GCI_QUARTILE_TABLE_HEADER_PPP_GCI = 'PPP GCI\nwith trend'
	public static readonly GCI_QUARTILE_TABLE_HEADER_PPP_SIDES = 'PPP Sides\nwith trend'
	public static readonly GCI_QUARTILE_TABLE_HEADER_PPP_SALES_VOLUME = 'PPP Sales volume\nwith trend'
	// GCI Quartile Performance Row Labels
	public static readonly GCI_QUARTILE_FIRST = 'First quartile'
	public static readonly GCI_QUARTILE_SECOND = 'Second quartile'
	public static readonly GCI_QUARTILE_THIRD = 'Third quartile'
	public static readonly GCI_QUARTILE_FOURTH = 'Fourth quartile'
	public static GCI_QUARTILE_AGENTS_COUNT(count: number): string {
		return `${count} agents`
	}
	public static readonly GROWTH_SCORE_TOOLTIP =
		'The Growth score predicts how likely an agent’s production will grow over the next two years. It uses a 1–5 scale, where 5 represents the top 20% of agents with the highest growth potential and 1 represents the bottom 20% with the lowest potential. Based on past transactions, tenure, and market trends, this score helps identify agents with future potential, even if their current production is modest.'
	public static readonly NET_REVENUE_SCORE_TOOLTIP =
		'The Net revenue score predicts the expected net revenue contribution of an agent over the next two years. It uses a 1–5 scale, where 5 represents the top 20% of agents with the highest predicted net revenue and 1 represents the bottom 20%. By combining projected sales volume with expected commission splits, this score helps recruiters prioritize agents who offer the greatest financial return.'
	public static readonly MLS_DATA_SETUP = 'We’re setting up your MLS data'
	public static readonly MLS_AGGREMENT_INFO_MESSAGE = (filteredMlsIdsCount: number) =>
		`Your MLS ${filteredMlsIdsCount > 1 ? 'agreements are' : 'agreement is'} active and we’re preparing your data. Prospect search will be available once setup is complete.`
	public static readonly MLS_SEARCH_AVALABILITY_INFO = 'MLS search will be available once setup is complete.'
	public static readonly MLS_DATA_AVAILABILITY_INFO = (mlsSystems: string) =>
		`Data for ${mlsSystems} is being prepared and will be available soon.`
	public static readonly FILTER_SORT = 'Filter and sort'
	public static readonly OUTREACH_OPPORTUNITY = 'Outreach opportunity'
	public static readonly OUTREACH_OPPORTUNITY_DESC = 'Sorts by prospects with little or no recent contact.'
	public static readonly ENGAGEMENT_PRIORITY = 'Engagement priority'
	public static readonly ENGAGEMENT_PRIORITY_DESC = 'Sorts by prospects with scheduled, overdue, or recent activity.'
	public static readonly SORT = 'Sort'
	public static readonly SORT_BY = 'Sort by'
	public static readonly ALL_OFFICES_LABEL = 'All Offices'
	public static readonly INCENTIVE_ESTIMATOR_TITLE = 'Incentive estimator'
	public static readonly INCENTIVE_ESTIMATOR_SUBTITLE =
		'Quickly create personalized, competitive offers with rich historical performance data, APEX modeling, and regional compensation guidelines.'
	public static readonly INCENTIVE_CONTAINER_TITLE = (firstNm: string) => `Estimate ${firstNm}'s incentive`
	public static readonly INCENTIVE_INFO_TEXT = (amount: number) =>
		`This amount will require a ${amount < 20000 ? 3 : 4}-year contract.`

	public static readonly INCENTIVE_INFO_SUB_TEXT = `Incentives above $30,000 require approval from Robert Hyde.`

	public static readonly AVERAGE_COMISSION_RATE = 'Average commission rate'
	public static readonly LTM_SALES_VOLUME = 'LTM sales volume'
	public static readonly LTM_TOTAL_SALES_VOLUME = 'LTM total sales volume'
	public static readonly LTM_ESTIMATED_GCI = 'LTM estimated GCI'
	public static readonly LMT_EST_GCI = 'LTM est. GCI'
	public static readonly EXPECTED_GROSS_PROFIT = 'Expected gross profit'
	public static readonly COMPANY_DOLLAR = 'Company dollar'
	public static readonly BRAND_ROYALTY_FEE = 'Brand royalty fee'
	public static readonly REFERRAL_BONUS_YR1 = 'Referral bonus (yr1)'
	public static readonly ADDITIONAL_LTM_SALES_VOLUME = 'Additional LTM sales volume'
	public static readonly OFF_MARKET_AND_OTHER_MLS_PRODUCTION = 'Any off-market & other MLS production.'
	public static readonly PROPOSED_COMPANY_SPLIT = 'Proposed company split %'
	public static readonly DEFAULT_AND_MLS_DATA = 'Default and MLS data'
	public static readonly CALCULATED_AMOUNTS = 'Calculated amounts'
	public static readonly ESTIMATED_INCENTIVE = 'Estimated incentive:'
	public static readonly SPLIT_BLANK_DEFAULTED = 'Split % cannot be blank. Defaulted to 20%.'
	public static readonly SPLIT_INVALID_RANGE = 'Split % must be a whole number between 0 and 100.'
	public static readonly AGENT_INCENTIVE_NOT_QUALIFIED_SUBTEXT = 'What are the qualifications for a TARP offer?'
	public static readonly INCENTIVE_QUALIFICATIONS = 'Incentive qualifications'
	public static readonly INCENTIVE_QUALIFICATIONS_SUBTEXT =
		"An agent's Estimated GCI must be greater than $50,000 to be eligible for an incentive bonus."
	public static readonly LISTING_STATUS = 'Listing status'
	public static readonly STREET_ADDRESS = 'Street address'
	public static readonly CITY = 'City'
	public static readonly ZIP_CODE = 'Zip code'
	public static readonly LIST_DATE = 'List date'
	public static readonly SALE_PRICE = 'Sale price'
	public static readonly DOM = 'DOM'
	public static readonly SIDES = 'Sides'
	public static readonly CO_BROKER_AGENT = 'Co-broker agent'
	public static readonly LISTINGS_DETAILED_VIEW = 'Detailed view of all listings from the past 5 years.'
	public static readonly LISTINGS_DETAILED_VIEW_LTM = 'Detailed view of all listings from the last 12 months.'
	public static readonly LISTINGS_DETAILED_VIEW_YTD = 'Detailed view of all listings year to date.'

	public static readonly PERFORMANCE_DETAILED_VIEW = 'Summary view of key production metrics from the past 5 years.'
	public static readonly PERFORMANCE_DETAILED_VIEW_LTM =
		'Summary view of key production metrics from the last 12 months.'
	public static readonly PERFORMANCE_DETAILED_VIEW_YTD = 'Summary view of key production metrics year to date.'
	public static readonly MLS_TOP_500_MESSAGE =
		'Displaying the top 500 agents by volume. Apply filters to refine your search.'
	public static PAGINATION_RESULTS_CAPPED_OUT_OF(
		first: number,
		last: number,
		cappedTotal: number,
		actualTotal: number
	): string {
		return `Showing ${first}-${last} of ${cappedTotal} results (out of ${actualTotal} agents).`
	}
	public static readonly EMPTY_STATE_ACTIVITY_MSG = 'There is no recent activity to display.'
	public static readonly RELOAD_PROSPECT_ACTIVITY = 'Reload'
	public static readonly PROSPECT_ACTIVITY_ERROR_MSG =
		'We’re having trouble loading prospect activity right now.\nPlease try refreshing this section.'
	public static readonly PROSPECT_ACTIVITY = 'Prospect activity'
	public static readonly MLS_LISTINGS_ERROR_MSG =
		'We’re having trouble loading listings data right now.\nPlease try reloading this section.'
	public static readonly MLS_LISTINGS_RELOAD = 'Reload listings data'
	public static readonly PROSPECT_NO_ACTIVITIES = 'There are no interactions.'
	public static readonly PROSPECT_NO_NOTES = 'There are no notes to display.'
	public static readonly LOGGED_ACTIVITY = 'Logged activity'
	public static readonly PIPELINE_INFO = 'Pipeline information'
	public static readonly NURTURE_INFO = 'Nurture pool information'
	public static readonly UPCOMING_EVENTS = 'Upcoming events'
	public static readonly EVENT_LIFECYCLE = 'Event lifecycle'
	public static readonly EVENT_TOOLTIP = (tmpBon2076PanelStandardization: boolean) =>
		`Upcoming events are shown here and automatically move to the ${tmpBon2076PanelStandardization ? 'Interaction history' : 'Recruiting log'}  once the event has passed.`
	public static readonly CREATE_EVENT = 'Create event'
	public static readonly EDIT_EVENT = 'Edit event'
	public static readonly NO_EVENTS = 'There are no upcoming events to display.'
	public static readonly AGENT_INCENTIVE_NOT_QUALIFIED = (prospect: string) =>
		`${prospect} is not currently eligible for an incentive offer. GCI must be $50k or more.`
	public static readonly AGENT_NOT_QUALIFIED = 'This agent does not qualify for an incentive.'
	public static readonly AGENT_NOT_QUALIFIED_SUBTEXT = (prospect: string) =>
		`${prospect} is a Compass International Holdings Real Estate Professional and does not qualify for an incentive offer.`
	public static readonly TODOS = 'To-dos'
	public static readonly CREATE_TODO = 'Create to-do'
	public static readonly TODO_LIFECYCLE = 'To‑do lifecycle'
	public static readonly TODO_TOOLTIP = (tmpBon2076PanelStandardization: boolean) =>
		`To‑dos appear here until they’re marked as complete. After completion, they’re moved to the ${tmpBon2076PanelStandardization ? 'Interaction history' : 'Recruiting log'}.`
	public static readonly DUE = 'Due'
	public static readonly OVERDUE = 'Overdue'
	public static readonly FUTURE = 'Future'
	public static readonly TODAY = 'Today'
	public static readonly TODAY_SENTENCE_CASE = 'today'
	public static readonly NO_TODOS = 'There are no upcoming to-do’s.'
	public static readonly VIEW_TODO = 'View to-do'
	public static readonly TITLE = 'Title'
	public static readonly TYPE = 'Type'
	public static readonly DETAILS_OPTIONAL = 'Details (optional)'
	public static readonly DUE_DATE = 'Due date'
	public static readonly DUE_TIME = 'Due time'
	public static readonly ASSIGNEE = 'Assignee'
	public static readonly REMINDER = 'Reminder'
	public static readonly CREATED_BY = 'Created by'
	public static readonly CREATE = 'Create'
	public static readonly SEND_ME_REMINDER = 'Send me reminder'
	public static readonly SEND_ME_REMINDER_SUBTEXT = 'Broker Workplace would send you reminder via email.'
	public static readonly TODO_DESCRIPTION_PLACEHOLDER = 'Add a brief description of the to-do'
	public static readonly OPTIONAL = '(optional)'
	public static readonly VIEW_NOTE = 'View note'
	public static readonly EDIT_NOTE = 'Edit note'
	public static readonly ADD_NOTE = 'Add note'
	public static readonly ADD_PROSPECT = 'Add prospect'
	public static readonly DELETE_NOTE = 'Delete note'
	public static readonly DELETE_EVENT = 'Delete event'
	public static readonly DELETE = 'Delete'
	public static readonly EDIT = 'Edit'
	public static readonly ADD_NOTE_PROSPECT = (firstNm: string) => `Please input note about ${firstNm}`
	public static readonly NOTE_DELETE_CONFIRMATION = 'Note deleted successfully.'
	public static readonly NOTE_ADD_CONFIRMATION = 'Note added successfully.'
	public static readonly NOTE_UPDATE_CONFIRMATION = 'Note updated successfully.'
	public static readonly NOTE_DELETE_MSG = 'Do you want to delete this note? This cannot be undone.'
	public static readonly RECRUTING_DELETE_MSG =
		'Do you want to delete this activity? The activity will be permanently deleted.'
	public static readonly RECRUITING_DELETE_INTERACTION_MSG =
		'Are you sure you want to delete this interaction? This action cannot be undone.'
	public static readonly EVENT_DELETE_MSG = 'Are you sure you want to delete this event? This action cannot be undone.'
	public static readonly EVENT_DELETE_CONFIRMATION = 'Event deleted.'
	public static readonly INTERACTION_DELETE_CONFIRMATION = 'Interaction deleted.'
	public static readonly INTERACTION_LOGGED_SUCCESSFULLY = 'Interaction logged.'
	public static readonly INTERACTION_UPDATED_SUCCESSFULLY = 'Interaction updated.'
	public static readonly EVENT_CREATE_ERROR = "We couldn't create this event."
	public static readonly EVENT_EDIT_ERROR = "We couldn't save your changes."
	public static readonly EVENT_DELETE_ERROR = "We couldn't delete this event."
	public static readonly VIEW_EVENT = 'View event'
	public static readonly EVENT_TITLE = 'Title'
	public static readonly EVENT_TYPE = 'Type'
	public static readonly EVENT_TIME = 'Time'
	public static readonly EVENT_FROM = 'From'
	public static readonly EVENT_TO = 'to'
	public static readonly EVENT_PARTICIPANTS = 'Participants'
	public static readonly EVENT_LOCATION = 'Location'
	public static readonly EVENT_DETAILS = 'Details'
	public static readonly EVENT_COMMENT = 'Comment'
	public static readonly EVENT_NOTE = 'Note'
	public static readonly EVENT_EMPTY_VALUE = '-'
	public static readonly EVENT_NO_MATCHES = 'No matches'
	public static readonly EVENT_LOCATION_PLACEHOLDER = 'Add a location'
	public static readonly EVENT_DETAILS_PLACEHOLDER = 'Add a brief description of the event'
	public static readonly EVENT_COMMENT_PLACEHOLDER = 'Add comment to this event'
	public static EVENT_CREATED_BY_ON = (creatorName: string, createdDate: string) =>
		`Created by ${creatorName} on ${createdDate}`
	public static readonly EVENT_CREATE_CONFIRMATION = 'Event created successfully.'
	public static readonly EVENT_UPDATE_CONFIRMATION = 'Event successfully updated.'
	public static readonly EVENT_LIFECYCLE_INFO_ARIA = 'Event lifecycle info'
	public static readonly ALL = 'All'
	public static readonly NOTES = 'Notes'
	public static readonly RECRUITING = 'Recruiting'
	public static readonly TODO = 'Todos'
	public static readonly EVENTS = 'Events'
	public static readonly LOG = 'Log'
	public static readonly OTHER = 'Other'
	public static readonly MARK_AS_COMPLETE = 'Mark as complete'
	public static readonly MARK_AS_INCOMPLETE = 'Mark as incomplete'
	public static readonly COMMENT_OPTIONAL = 'Comment'
	public static readonly COMPLETED_DATE = 'Completed date'
	public static readonly COMPLETED_TIME = 'Completed time'
	public static readonly COMPLETED_BY = 'Completed by'
	public static readonly EDIT_TODO = 'Edit to-do'
	public static readonly TODO_CREATION_ERROR = 'We couldn’t create this to-do.'
	public static readonly TODO_COMPLETION_CONFIRMATION = 'To-do marked as complete.'
	public static readonly TODO_INCOMPLETION_CONFIRMATION = 'To-do marked incomplete.'
	public static readonly TODO_COMPLETION_TITLE = 'To-do couldn’t be marked as complete.'
	public static readonly TODO_COMPLETION_ERROR = 'We couldn’t mark this as complete.'
	public static readonly TODO_INCOMPLETION_TITLE = 'To-do couldn’t be marked as incomplete.'
	public static readonly TODO_INCOMPLETION_ERROR = 'We couldn’t mark this as incomplete..'
	public static readonly TODO_NAME_ERROR = 'To-do name cannot be empty.'
	public static readonly TODO_DUE_DATE_ERROR = 'Due date must be in the future.'
	public static readonly TODO_DUE_TIME_ERROR = 'Due time must be in the future.'
	public static readonly TODO_ASSIGNEE_ERROR = 'Assignee must be a member of your brokerage.'
	public static readonly TODO_TYPE_ERROR = 'To-do type must be selected.'
	public static readonly DELETE_TODO = 'Delete to-do'
	public static readonly DELETE_TODO_MSG = 'Are you sure you want to delete this to-do? This action cannot be undone.'
	public static readonly TODO_DELETE_CONFIRMATION = 'To-do deleted successfully.'
	public static readonly TODO_DELETE_TITLE = 'To-do couldn’t be deleted.'
	public static readonly TODO_DELETE_ERROR = 'We couldn’t delete this to-do.'
	public static readonly TODO_UPDATE_ERROR = 'We couldn’t save your changes.'
	public static readonly TODO_NAME_REQUIRED = 'To-do name is required.'
	public static readonly TODO_TYPE_REQUIRED = 'To-do type is required.'
	public static readonly TODO_DUE_DATE_REQUIRED = 'Due date is required.'
	public static readonly TODO_ASSIGNEE_REQUIRED = 'Assignee is required.'
	public static readonly TODO_NAME = 'To-do name'
	public static readonly TODO_DESCRIPTION = 'To-do description'
	public static readonly TODO_TYPE = 'To-do type'
	public static readonly ADD_INTERACTION = 'Add interaction'
	public static readonly INTERACTION = 'Interaction'
	public static readonly AGENT_CONVERTED = 'Agent Converted'
	public static readonly CONVERT_AGENT = 'Convert agent'
	public static readonly AGENT_CONVERTED_DETAIL = (name: string) =>
		`${name} has been converted to your agent. All open to‑dos and events have been removed.`
	public static readonly AGENT_CONVERTION_MESSAGE_PIPELINE = (name: string) =>
		`${name} must be marked as converted to remove them from the pipeline.`
	public static readonly AGENT_CONVERTION_MESSAGE_NURTURE = (name: string) =>
		`${name} must be marked as converted to remove them from the nurture pool.`
	public static readonly ADD_TO_PIPELINE_TODO = 'To create a to-do, the agent needs to be added to pipeline.'
	public static readonly ADD_TO_PIPELINE_EVENT = 'To create an event, the agent needs to be added to pipeline.'
	public static readonly ACTIVTY_DESCRIPTION_HOVER = 'To log an activity, the agent needs to be added to pipeline.'
	public static readonly ACTIVITY_TITLE_HOVER = 'Agent is not in pipeline'
	public static readonly NO_CONTACT = 'No contact'
	public static readonly NOT_CONTACTED = 'Not contacted'
	public static readonly DUE_FOR_OUTREACH = 'Due for outreach'
	public static readonly DUE_FOR_OUTREACH_DESCRIPTION = 'No interactions in the past 3+ weeks and no upcoming activity.'
	public static readonly CUSTOMIZE_CARDS = 'Customize cards'
	public static readonly ENGAGEMENT_STATUS = 'Engagement status'
	public static readonly UPCOMING_INTERACTIONS = 'Upcoming interactions'
	public static readonly UPCOMING = 'Upcoming'
	public static readonly NEEDS_OUTREACH = 'Needs outreach'
	public static readonly RECENTLY_ENGAGED = 'Recently engaged'
	public static readonly ACTIVITY_DELETE_TITLE = 'Activity couldn’t be deleted.'
	public static readonly ACTIVITY_DELETE_ERROR = 'Activity couldn’t be deleted. Please try again.'
	public static readonly ACTIVITY_DELETE_CONFIRMATION = 'Activity deleted successfully.'
	public static readonly NO_MATCHES = 'No matched data found'
	public static readonly LOG_ACTIVITIES = 'Log activity'

	public static readonly PREVIEW = 'Preview'
	public static readonly CO_BROKER = 'Co-broker'
}
